//プロフィール画像表示component
import React, {Component} from 'react';
import './css/topVisitor1.css';


export default class Profileimage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			newImage:'',
			oldImage:''
		}
	}

	componentWillReceiveProps = (state) => {
		if(state.user.facebookId !== this.props.user.facebookId || state.user.updatePhoto !== this.props.user.updatePhoto) {
			this.getNewImage(state.user)
			this.getOldImage(state.user)
		}
	}
	componentDidMount = () => {
		this.getNewImage()
		this.getOldImage()
	}	

	getNewImage = (userdata) => {
		let user = userdata ? { ...userdata } : { ...this.props.user }
		let newImage = user.hasOwnProperty('updatePhoto') ? user.updatePhoto : ''
		this.setState({newImage:newImage})
	}

	getOldImage = (userdata) => {
		let user = userdata ? { ...userdata } : { ...this.props.user }
		if (user.facebookId) {
			this.setState({oldImage:'https://graph.facebook.com/' + user.facebookId + '/picture?width=250&height=250'})
		} else {
			this.setState({oldImage: '/img/common/m-profile-img@2x.png'})
		}
	}

	setImage = () => {
		const {
			newImage,
			oldImage
		} = this.state
		return newImage ? newImage : oldImage;
	}

	changePhoto = (e) => {
		e.preventDefault()		
		this.props.changePhoto(true)
	}

	render() {
		return (
			<div>
				<h2 className="subtitle">プロフィール写真</h2>
				<div className="profile-image">
					<img src={this.setImage()} alt="" />
				</div>
				<a onClick={this.changePhoto} className="btn-chan align-center">変更する</a>
				<hr className="border-gray" />
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/profileImage.js